// Code generated by tools/scripts/generate-agent-live-protocol.mjs. DO NOT EDIT.

export const AGENT_ACTIVITY_LIVE_PROTOCOL_REVISION =
  "sha256:8474280d7426e57b" as const;
